import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.timer = setTimeout(() => {
      this.element.remove()
    }, 30000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
